import type { FC } from 'react';
import {
  DESKTOP_ZOOM_CONTROLS_MAX_TOP_PX,
  DESKTOP_ZOOM_CONTROLS_WIDTH,
  ZOOM_CONTROLS_HALF_STACK_HEIGHT_PX,
} from '../constants/seatMap';

type ZoomControlsProps = {
  canZoomIn: boolean;
  canZoomOut: boolean;
  hidden?: boolean;
  onZoomIn: () => void;
  onZoomOut: () => void;
};

const ZoomControls: FC<ZoomControlsProps> = ({
  canZoomIn,
  canZoomOut,
  hidden = false,
  onZoomIn,
  onZoomOut,
}) => {
  if (hidden) return null;

  const stopControlEventPropagation = (event: React.SyntheticEvent) => {
    event.stopPropagation();
  };

  return (
    <div
      className="relative z-[20] shrink-0"
      style={{ width: DESKTOP_ZOOM_CONTROLS_WIDTH }}
      data-seatmap-control="zoom-controls"
      onClick={stopControlEventPropagation}
      onPointerDown={stopControlEventPropagation}
      onPointerUp={stopControlEventPropagation}
    >
      <div
        className="absolute inset-x-0 flex flex-col items-center gap-3"
        style={{
          top: `clamp(0px, calc(50% - ${ZOOM_CONTROLS_HALF_STACK_HEIGHT_PX}px), ${DESKTOP_ZOOM_CONTROLS_MAX_TOP_PX}px)`,
        }}
      >
        <button
          type="button"
          onClick={onZoomIn}
          disabled={!canZoomIn}
          data-seatmap-control="zoom-in"
          className={`flex h-10 w-10 items-center justify-center rounded-full text-xl font-medium shadow-[var(--shadow-md)] transition-all ${
            !canZoomIn
              ? 'cursor-not-allowed bg-surface-card text-text-secondary opacity-50'
              : 'cursor-pointer bg-surface-card text-text-secondary hover:bg-action-ghost-hover hover:text-text-primary active:bg-action-secondary-hover hover:scale-105 active:scale-95'
          }`}
          aria-label="Увеличить масштаб"
        >
          <span className="relative -top-px">+</span>
        </button>

        <button
          type="button"
          onClick={onZoomOut}
          disabled={!canZoomOut}
          data-seatmap-control="zoom-out"
          className={`flex h-10 w-10 items-center justify-center rounded-full text-xl font-medium shadow-[var(--shadow-md)] transition-all ${
            !canZoomOut
              ? 'cursor-not-allowed bg-surface-card text-text-secondary opacity-50'
              : 'cursor-pointer bg-surface-card text-text-secondary hover:bg-action-ghost-hover hover:text-text-primary active:bg-action-secondary-hover hover:scale-105 active:scale-95'
          }`}
          aria-label="Уменьшить масштаб"
        >
          <span className="relative -top-px">−</span>
        </button>
      </div>
    </div>
  );
};

export default ZoomControls;
